import apiClient from "./index";

export const save = cntnStats => {
  return apiClient.post(`/sys/cntnStats/saveProc.json`, cntnStats);
}

// 사용자 접속 통계
export const selectUserCntnStatsProc = data => {
  return apiClient.post(`/sys/cntnStats/selectUserCntnStatsProc.json`, data);
}

// 메뉴별 접속 통계
export const selectMenuCntnStatsProc = data => {
  return apiClient.post(`/sys/cntnStats/selectMenuCntnStatsProc.json`, data);
}

// 게시판 접속 통계
export const selectBbsCntnStatsProc = data => {
  return apiClient.post(`/sys/cntnStats/selectBbsCntnStatsProc.json`, data);
}